
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    TextField,
    Button,
    Typography,
    Paper,
    Alert
} from '@mui/material';

import api from './api';

const SignUp1 = () => {

    const [updateValue, setUpdateValue] = useState({
        name: "",
        email: "",
        password: "",
        confirmPassword: ""
    });

    const [message, setMessage] = useState("");

    const navigate = useNavigate();

    function updateUser(e) {
        const key = e.target.name;

        setUpdateValue({
            ...updateValue,
            [key]: e.target.value
        });
    }

    async function setValues(event) {
        event.preventDefault();

        setMessage("");

        if (
            !updateValue.name ||
            !updateValue.email ||
            !updateValue.password ||
            !updateValue.confirmPassword
        ) {
            setMessage("Please fill all the details");
            return;
        }

        if (updateValue.password !== updateValue.confirmPassword) {
            setMessage("Password Mismatch");
            return;
        }

        try {
            const res = await api.post("/auth/addNewUser", {
                name: updateValue.name,
                email: updateValue.email,
                password: updateValue.password
            });

            setMessage(res.data.message);

            setUpdateValue({
                name: "",
                email: "",
                password: "",
                confirmPassword: ""
            });

            navigate("/login");

            console.log(res.data.message);

        } catch (e) {
            console.log(e.message);

            setMessage(
                e.response?.data?.error || "Something went wrong"
            );
        }
    }

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#f5f5f5",
                padding: 2
            }}
        >
            <Paper
                elevation={4}
                sx={{
                    width: "100%",
                    maxWidth: 420,
                    padding: 4,
                    borderRadius: 3
                }}
            >
                <Box
                    component="form"
                    onSubmit={setValues}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 2
                    }}
                >

                    <Typography
                        variant="h4"
                        textAlign="center"
                        fontWeight="bold"
                    >
                        Sign Up
                    </Typography>

                    {message && (
                        <Alert severity="error">
                            {message}
                        </Alert>
                    )}

                    <TextField
                        label="Name"
                        type="text"
                        name="name"
                        placeholder="Enter Name"
                        value={updateValue.name}
                        onChange={updateUser}
                        fullWidth
                    />

                    <TextField
                        label="Email"
                        type="email"
                        name="email"
                        placeholder="Enter Email"
                        value={updateValue.email}
                        onChange={updateUser}
                        fullWidth
                    />

                    <TextField
                        label="Password"
                        type="password"
                        name="password"
                        placeholder="Enter Password"
                        value={updateValue.password}
                        onChange={updateUser}
                        fullWidth
                    />

                    <TextField
                        label="Confirm Password"
                        type="password"
                        name="confirmPassword"
                        placeholder="Confirm Password"
                        value={updateValue.confirmPassword}
                        onChange={updateUser}
                        fullWidth
                    />

                    <Button
                        type="submit"
                        variant="contained"
                        size="large"
                        fullWidth
                    >
                        Sign Up
                    </Button>

                </Box>
            </Paper>
        </Box>
    );
};

export default SignUp1;
